/* User Permissions */
export const userPermissionConstants = Object.freeze({
  ADD_USERS: 'ADD_USERS',
  VIEW_USERS: 'VIEW_USERS',
  SWITCH_CLIENT: 'SWITCH_CLIENT',
  VIEW_ROLE_MANAGEMENT: 'VIEW_ROLE_MANAGEMENT',
  UPLOAD_ORDER_DOCUMENT: 'UPLOAD_ORDER_DOCUMENT',
  CHANGE_ROLE: 'CHANGE_ROLE',
})
